import { VendorDetailsModalConfig } from 'src/modals/VendorDetails';

export const getVendorDetailsModalConfigWithDeepLink = (vendorId: number) => {
  return {
    ...VendorDetailsModalConfig,
    deepLinkValue: vendorId,
  };
};
